import React, {useEffect, useState, useContext} from 'react';
import { db } from '../firebase';
import {LibrosContext} from '../Context/LibrosProvider';
import {UsuarioContext} from '../Context/UsuarioProvider';

const MostrarAutor = (props) => {

    const {usuario} = useContext(UsuarioContext)
    const {fetchLibros} = useContext(LibrosContext)
    
    const [autor, setAutor] = useState('')

    useEffect(() => {
        fetchAutor()
    }, [])

    const eliminarLibro = async() => {
        try {
            await db.collection('libros').doc(props.id).delete()
            fetchLibros()
        } catch (error) {
            console.log(error)
        }
    }

    const fetchAutor = async() => {
        try {
            const res = await props.referencia.get()
            console.log(res.data())
            setAutor(res.data().email)
        } catch (error) {
            console.log(error)
        }
    }

    return (
        <>
            <span> {autor}</span>
            {
                (autor === usuario.email || usuario.rol === 'admin') && (
                    <button
                        onClick={eliminarLibro}
                        className="btn btn-danger float-right"
                    >
                        Eliminar
                    </button>
                )
            }
        </>
    )
}

export default MostrarAutor
